import createLucideIcon from '../createLucideIcon';

/**
 * @component @name Wand
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgNFYyIiAvPgogIDxwYXRoIGQ9Ik0xNSAxNnYtMiIgLz4KICA8cGF0aCBkPSJNOCA5aDIiIC8+CiAgPHBhdGggZD0iTTIwIDloMiIgLz4KICA8cGF0aCBkPSJNMTcuOCAxMS44IDE5IDEzIiAvPgogIDxwYXRoIGQ9Ik0xNSA5aC4wMSIgLz4KICA8cGF0aCBkPSJNMTcuOCA2LjIgMTkgNSIgLz4KICA8cGF0aCBkPSJtMyAyMSA5LTkiIC8+CiAgPHBhdGggZD0iTTEyLjIgNi4yIDExIDUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/wand
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Wand = createLucideIcon('Wand', [
  ['path', { d: 'M15 4V2', key: 'z1p9b7' }],
  ['path', { d: 'M15 16v-2', key: 'px0unx' }],
  ['path', { d: 'M8 9h2', key: '1g203m' }],
  ['path', { d: 'M20 9h2', key: '19tzq7' }],
  ['path', { d: 'M17.8 11.8 19 13', key: 'yihg8r' }],
  ['path', { d: 'M15 9h.01', key: 'x1ddxp' }],
  ['path', { d: 'M17.8 6.2 19 5', key: 'fd4us0' }],
  ['path', { d: 'm3 21 9-9', key: '1jfql5' }],
  ['path', { d: 'M12.2 6.2 11 5', key: 'i3da3b' }],
]);

export default Wand;
